import { AvatarWithStatusProps } from '@modules/talents/components/AvatarWithStatus';

import { MultiSelectTalent } from './type';

export const getMultiSelectTalentStatus = (talents: MultiSelectTalent[]): AvatarWithStatusProps['status'] => {
    if (talents.length === 0) return 'nothing';

    const statuses = talents.map(talent => talent.status);
    const uniqueStatuses = new Set(statuses);

    // If all selected talents have the same status, use that status
    if (uniqueStatuses.size === 1 && statuses.length > 0) {
        return statuses[0] as AvatarWithStatusProps['status'];
    }

    // If mixed statuses, return 'mixed'
    return 'mixed';
};
